export type CalendarEntry<T> = {
  id: string,
  startDatetime: number,
  details: T,
}

export type CalendarData = {
  [index: number]: CalendarEntry<any>[]
}

export enum AnimateType {
  None = 'none',
  Right = 'right',
  Left = 'left',
  Shake = 'shake',
}
